import { useState, useEffect, useContext } from 'react';
import { ListGroup, Badge, Col, Row } from 'react-bootstrap';
import { useLocation,useNavigate } from 'react-router-dom';
import IconButton from '../IconButton/IconButton';
import { CountContext } from '../../Contexts';
import { DateHelper } from '../../Utils';
import ToolTip from '../ToolTip/Tooltip';
import { SvgComponent } from '../SvgComponent/SvgComponent';

export function Casos({ list }) {

    const countContext = useContext(CountContext);
    const navigate = useNavigate();
    const [casos, setCasos] = useState([]);
    const { count, setCount } = countContext
        ? countContext
        : {};

    useEffect(() => {
        if (list) {
            setCasos(list);
            if (setCount) setCount(list.length);
        }
    }, [list]);

    const handleClick = (params) => {
        let urlBase = `/CasoView?`;
        let parametros = "";
        if (params) {
            const { Id } = params;
            if (Id) {
                urlBase = `/CasoView?`;
                parametros += `Id=${Id}`;
            }
        }
        navigate(urlBase + parametros);
    };

    return (
        <div className="col-md-12 mb-4">
            <div
                style={{
                    overflowY: "auto",
                    //dejar maxheigt en 70vh hasta que se vayan agregando mas. prev(30vh)
                    maxHeight: `70vh`,
                }}
                className="card m-b-30 mt-0 p-0"
            >
                {casos.length > 0 ? (
                    <ListGroup as="ol" numbered={"true"} className="">
                        {casos?.map((caso) => {
                            return (
                                <ListGroup.Item
                                    key={caso.Id}
                                    as="li"
                                    className="d-flex justify-content-between align-items-start"
                                    /*style={{ paddingRight: "0px" }}*/
                                >
                                    <Col className="m-0 p-0">
                                        <div className="ms-2 me-auto">
                                            <div className="fw-bold">{`${caso.NombreCaso}${
                                                caso.EstatusDesc ? `  (${caso.EstatusDesc})` : ""
                                            }`}</div>
                                            {/* Dejando el comentario por si despues es necesario poner la descripcion de nuevo */}
                                            {/* <strong style={{ fontSize: "1.4vh" }}>
                        {RichTextBoxHelper.getText(caso.Descripcion)}
                      </strong> */}
                                        </div>
                                        <Row className="m-0 p-0 justify-content-between">
                                            <div className="text-muted small">
                                                {`${
                                                    caso._TipoSolicitudDesc
                                                        ? `${caso._TipoSolicitudDesc}  `
                                                        : ""
                                                }`}
                                            </div>
                                            <div className="text-muted small">
                                                {DateHelper.formatStringDate(caso.FechaCreacion)}
                                            </div>
                                        </Row>
                                    </Col>
{/*                                    <Badge bg="bf" pill>
                                        <IconButton
                                            onClick={() => {
                                                handleClick({ Id: caso.IdSec });
                                            }}
                                        >
                                            <ToolTip message="Visualizar">
                                                <SvgComponent
                                                    iconName="view"
                                                    height="20px"
                                                    width="20px"
                                                />
                                            </ToolTip>
                                        </IconButton>
                                    </Badge>*/}
                                </ListGroup.Item>
                            );
                        })}
                    </ListGroup>
                ) : (
                    <h1 className="h6 pl-4">Sin Solicitudes</h1>
                )}
            </div>
        </div>
    );
}
